<template>
  <!-- <div v-if="netoff" class="netoff"> </div> --> 
  <div
    :class="
      $store.state.netOff
        ? 'home categoryHome netoffContent'
        : 'home categoryHome'
    "
  >
    <div class="liveContentPanel">
      <!-- <div class="circle"></div> -->
      <div class="liveUserScreen">
        <div class="main-container">
          <div class="withLiveUserHeader">
            <GoliveTitle />
            <!-- <div class="languageOption">
              <div class="whatNewbtn" @click="whatsNewmodel()">
                {{ $t('whatsnew') }}
              </div>
            </div> -->
          </div>
          <loading :active.sync="isLoading"></loading>
          <!-- <CategoryCards /> -->
          <RoomListing />
        </div>
      </div>
      <WhatsNew />
      <footer>
        <GoliveButtonComponents @handleJoinEvent="handleJoin" />
      </footer>
    </div>
    <!-- <div class="overlayPopBg"></div>
    <div class="indpendent-content">
      <span class="popClose" @click="modelclose()">
        <i class="material-icons">
          close
        </i>
      </span>
      <div class="innerindpendent">
        <div class="innerBox">
          <div class="logo-box">
            <img src="../assets/images/indipendentday-logo.png" />
            <span class="winicon">
              <img src="../assets/images/winnerIcon.png" />
            </span>
          </div>

          <div class="dtlcontexBox">
            <div class="eventPrgpanel">
              <h2>Event End</h2>
              <div class="eventCountbox">
                <div class="count_col"   v-for="(data, key) in timerLeft">
                  <span class="text_title">{{key}}</span>
                  <span class="counter_val">{{data}}</span>
                </div>

               
              </div>
              <h2>यह इवेंट मनी 91 के users के लिए है।</h2>
            </div>

            <div class="giftpanel">
              <h2>टॉप १० लोगो को मिलेंगे</h2>
              <span class="priceBtntext">₹1000</span>
              <h2>मूल्य के नकद पुरस्कार |</h2>
            </div>

            <div class="innerBox rulescnt">
              <h2>आपको पॉइंट्स मिलने के मापदंड है</h2>
              <ul>
                <li>की आप कितने देर लाइव जाते हैं।</li>
                <li>आपके लाइव से कितने लोग जुड़ते है।</li>
                <li>आपके लाइव पे कितने लोग कमेंट करते हैं।</li>
                <li>आपको लोग कितने हर्ट्स भेजते है।</li>
              </ul>
            </div>

            <div class="innerBox">
              <span class="starIcon">*</span>
              <p>विनिंग अमाउंट आपके मनी 91 वॉलेट में क्रेिडट कर दिया जायेगा।</p>
              <p>
                धोखाधड़ी या अनुिचत साधनों का उपयोग करते हुए अंक अर्जित करने के
                लिए अयोग्य घोषित और प्रतिबंधित कर दिया जाएगा।
              </p>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import * as Cookies from 'js-cookie'
import Loading from 'vue-loading-overlay'
import WhatsNew from '../components/WhatsNew'
import GoliveTitle from '../components/GoliveTitle'
import CategoryCards from '../components/CategoryCards'
import GoliveButtonComponents from '../components/GoliveButtonComponents'
import { BASE_API_URL } from '../utils/constant'
import { Timer } from '../utils/helper'
import RoomListing from './RoomListing'

export default {
  name: 'categoryHome',
  components: {
    Loading,
    WhatsNew,
    CategoryCards,
    GoliveTitle,
    RoomListing,
    GoliveButtonComponents
  },
  props: {
    msg: String
  },

  data() {
    return {
      interval: null,
      netOff: false,
      preloader: true,
      whatsNewmodelOpen: false,
      previousCategoryViewer: '',
      selectedCategoryViewer: this.$store.getters.selected,
      isLoading: false,
      bootOutUserData: null,
      channel: '',
      attendeeMode: 'video',
      liveUser: [],
      timerLeft: {},
      xAuthId: Cookies.get('X-Auth-Id') || null,
      permission: [
        'android.permission.CAMERA',
        'android.permission.RECORD_AUDIO',
        'android.permission.WRITE_EXTERNAL_STORAGE',
        'android.permission.READ_EXTERNAL_STORAGE'
      ]
    }
  },

  beforeDestroy() {
    document.querySelector('body').classList.remove('popbody')
  },

  mounted() {
    this.changeLocale()
    navigator.connection.onchange = () => {
      if (navigator.connection.downlink < 0.5) {
        this.$toast.bottom(this.$t('netSlow'))
      } else if (navigator.connection.downlink === 10) {
        this.$store.commit('netOff', true)
        this.$toast.bottom(this.$t('startNet'))
      } else {
        this.$store.commit('netOff', false)
      }
    }
  },

  methods: {
    modelclose() {
      document.querySelector('body').classList.remove('popbody')
      try {
        window.clearInterval(this.interval)
      } catch (err) {
        console.log('---', err)
      }
    },

    changeLocale(locale) {
      if (['bn', 'gu'].includes(this.$cookie.get('lang'))) {
        document.querySelector('body').classList.add('lang-multi')
      }
      if (['ml'].includes(this.$cookie.get('lang'))) {
        document.querySelector('body').classList.add('lang-ml')
      }
      if (['pa', 'kn'].includes(this.$cookie.get('lang'))) {
        document.querySelector('body').classList.add('lang-pa')
      }
      if (['ta'].includes(this.$cookie.get('lang'))) {
        document.querySelector('body').classList.add('lang-ta')
      }
      if (['te'].includes(this.$cookie.get('lang'))) {
        document.querySelector('body').classList.add('lang-te')
      }
      console.log('lang>> ', this.$cookie.get('lang'))
      this.$i18n.locale = this.$cookie.get('lang') || 'hi'
    },
    handleDateCounter() {
      this.timerLeft = Timer('15 August 2019')
      console.log('0==time==', this.timerLeft)
    },
    handleJoin() {
      clevertap.event.push('GOING_TO_BROADCAST', {
        id: this.xAuthId
      })
      this.isLoading = true
      var appVersion = Cookies.get('version-code')
      if (appVersion >= 44) {
        this.$http
          .post(BASE_API_URL + '/user_verification', {
            xAuthId: Cookies.get('X-Auth-Id')
          })
          .then(result => {
            if (result.body.allowed) {
              var _ = [
                'android.permission.CAMERA',
                'android.permission.RECORD_AUDIO',
                'android.permission.WRITE_EXTERNAL_STORAGE',
                'android.permission.READ_EXTERNAL_STORAGE'
              ]
              this.$router.push({
                path: 'video',
                query: { u: this.attendeeMode, c: this.channel }
              })
              JSBridgePlugin.checkForPermission(
                _,
                true,
                '__native_money91.checkForPermissionResult'
              )
            } else {
              this.$toast.bottom(result.body.message)
            }
            this.isLoading = false
          })
      } else {
        this.$toast.bottom(this.$t('upgradeApp'))
      }
    },
    openModal() {
      $('#yTVideoModal').modal('show')
      $('#yTVideoModal').on('hide.bs.modal', function(e) {
        var $if = $(e.delegateTarget).find('iframe')
        var src = $if.attr('src')
        $if.attr('src', '/empty.html')
        $if.attr('src', src)
      })
    },

    whatsNewmodel() {
      $('.whatconttentbox').modal('show')
    }
  }
}
</script>
<style scoped>
.noLiveUserScreen {
  left: 50%;
  top: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}
.noLiveUserScreen .main-container {
  height: 250px;
}
.noLiveUserScreen .main-container .btn {
  float: right;
  margin: 10px;
  font-size: 16px;
}
.liveUserScreen .main-container {
  /* height: auto; */
}
</style>
